import { render, staticRenderFns } from "./Marcas.vue?vue&type=template&id=39b90850"
import script from "./Marcas.vue?vue&type=script&lang=js"
export * from "./Marcas.vue?vue&type=script&lang=js"
import style0 from "./Marcas.vue?vue&type=style&index=0&id=39b90850&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports